import React from "react";
import { TestimonialCard } from "./TestimonialCard";
import { TitleUnderline } from "./TitleUnderline";
import { testimonials } from "../data/testimonials";
export function Testimonials() {
  return <section id="stimmen" aria-labelledby="testimonials-title" className="flex w-full scroll-mt-24 items-center bg-cream md:min-h-[calc(100svh-4rem)]" data-id="element-265" data-mp="3fyvyycq5phc5">
      <div className="mx-auto w-full max-w-7xl px-5 py-10 md:px-10 md:py-6 xl:py-[2.5vh]" data-id="element-266" data-mp="36ypo6yluevgo">
        <div className="grid gap-5 md:grid-cols-12 md:items-end md:gap-6" data-id="element-267" data-mp="31zw8r0mzwudv">
          <h2 id="testimonials-title" className="font-serif text-4xl font-medium leading-tight text-espresso sm:text-5xl md:col-span-7 md:text-4xl lg:col-span-6 xl:text-5xl" data-id="element-268" data-mp="321z9aelry5wu">
            Was meine Autorinnen und Autoren <TitleUnderline data-id="element-269" data-mp="v9yex8b87p8o">erleben</TitleUnderline>
          </h2>
          <p className="text-lg font-light leading-relaxed text-cocoa md:col-span-5 md:text-base md:leading-snug lg:col-start-8 xl:text-lg xl:leading-relaxed" data-id="element-270" data-mp="v72jbqmupcne">
            Menschen, die lange von ihrem Buch geträumt haben – und es mit der FlowKus-Methode endlich geschrieben
            haben. Hör selbst.
          </p>
        </div>

        <div className="mt-10 grid gap-10 md:mt-6 md:grid-cols-2 md:gap-5 lg:grid-cols-4 xl:mt-[4vh] xl:gap-6" data-id="element-271" data-mp="78a9nck2djfn">
          {testimonials.map(t => <TestimonialCard key={t.id} testimonial={t} data-id="element-272" data-mp="c8y0ny8am09v" />)}
        </div>
      </div>
    </section>;
}